import { render, staticRenderFns } from "./xeCarbonSaving.vue?vue&type=template&id=f3550b16&scoped=true"
import script from "./xeCarbonSaving.vue?vue&type=script&lang=js"
export * from "./xeCarbonSaving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3550b16",
  null
  
)

export default component.exports